import { render, staticRenderFns } from "./RoomReservationManager.vue?vue&type=template&id=160c2061&scoped=true&"
import script from "./RoomReservationManager.vue?vue&type=script&lang=js&"
export * from "./RoomReservationManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160c2061",
  null
  
)

export default component.exports